/** @module csi/widget/_svg/AddImageToPlaceholder */
define([
	"dijit/form/ToggleButton",
	"csi/locale",
	"csi/message",
	"csi/widget/MessageDialog",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(ToggleButton,locale,message,MessageDialog,_Plugin,PluginFactory,util) {

	return PluginFactory.declare([ToggleButton,_Plugin], {
		"class": "csi-button-toggle csi-single-toggle",
		bHideWhenDisabled: false,
		materialIcon: "photo",
		pluginName: "addImageToPlaceholder",
		title: "AddImageToPlaceholder",

		/**
		 * @override
		 * Enable on single image placeholder selection only
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			if (shapes.length) {
				return (
						shapes.length === 1 &&
						!shapes[0].attributeKey &&
						(shapes[0].imagePlaceholder || shapes[0].isPictureFromPlaceholder)
				);
			}

			return false;
		},

		/** Set button unchecked and call insertImagePlaceholder on selected object on click */
		onClick: function() {
			this.set("checked", false);
			this.getView().insertImagePlaceholder(this.editor.canvasApp.selection.selectedBaseObjects());
		}
	});
});
